import { useSelector } from 'react-redux';

import { useAmount } from '../../hooks/useAmount';
import { useIntl } from '../../hooks/useIntl';
import {
  roundSelector,
  shouldCelebrateSelector,
  tipsOnResultSelector,
  winnerListConfigSelector,
} from '../../store/selectors';

export type WinAmountValue = {
  currency?: string;
  value: string | number;
  sign?: string;
  label: string;
  visible: boolean;
};

const useGameResults = () => {
  const winnerListConfig = useSelector(winnerListConfigSelector);
  const round = useSelector(roundSelector);
  const tipsOnResultAllowed = useSelector(tipsOnResultSelector) as boolean;

  const shouldCelebrate = useSelector(shouldCelebrateSelector);

  const { winLabel } = useIntl({
    keys: {
      winLabel: 'games_ui.you_win',
    },
  });

  const { winAmountDisplay } = useAmount({
    values: {
      winAmountDisplay: {
        value: round.winAmount ?? 0,
        type: 'bet',
        showCurrencySymbol: winnerListConfig.showCurrencySymbol,
        showCurrencyCode: winnerListConfig.showCurrencyCode,
      },
    },
  });

  const isWinner = (round.winAmount ?? 0) > 0;

  const winAmount: WinAmountValue = {
    value: winAmountDisplay,
    label: winLabel,
    visible: isWinner,
  };

  return { winAmount, isWinner, shouldCelebrate, tipsOnResult: tipsOnResultAllowed && winAmount.visible };
};

export { useGameResults };
